'use client'

import { useLocale, useTranslations } from 'next-intl'

import { Button, Icon } from '@/shared/ui'

import { useGetContractRoom } from '../../api/get-contract-room'

type Props = {
  roomId: number
  contractId: number
  roomUrl: string
}

export const RoomDetailButton = ({ roomId, contractId, roomUrl }: Props) => {
  const locale = useLocale()
  const t = useTranslations('lease_detail')

  const { getContractRoom } = useGetContractRoom()

  const handleClick = async () => {
    const { response: contractRoom } = await getContractRoom(roomId, contractId)

    if (contractRoom) {
      window.open(`/${locale}${roomUrl}`, '_blank', 'noopener,noreferrer')
    }
  }

  return (
    <Button
      variant="outline"
      size="medium"
      color="primary"
      shape="pill"
      fullWidth
      onClick={handleClick}
    >
      {t('button.unit_details')}
      <Icon name="arrow-right" />
    </Button>
  )
}
